// Production-safe logging utility
// Only logs when REACT_APP_DEBUG is enabled or in development mode

const isDevelopment = process.env.NODE_ENV === 'development';
const isDebugEnabled = process.env.REACT_APP_DEBUG === 'true';

const shouldLog = isDevelopment || isDebugEnabled;

const logger = {
  log: (...args) => {
    if (shouldLog) {
      console.log(...args);
    }
  },
  error: (...args) => {
    // Always log errors
    console.error(...args);
  },
  warn: (...args) => {
    if (shouldLog) {
      console.warn(...args);
    }
  },
  info: (...args) => {
    if (shouldLog) {
      console.info(...args);
    }
  }
};

export default logger;
